import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import s from "./CenteredImage.pcss";

const CenteredImage = props => (
    <div className={classNames(props.className, s.imageContainer)} data-test-id={"pop-card-img"}>
        <img alt={props.alt} src={props.src} className={s.image} />
    </div>
);

CenteredImage.propTypes = {
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
};

CenteredImage.defaultProps = {
    className: "",
};

export default CenteredImage;
